import React from "react";
import { MessageCircle, Gem, BadgeCheck, Instagram } from "lucide-react";

const items = [
  { icon: MessageCircle, label: "Direct WhatsApp Enquiry" },
  { icon: Gem, label: "Gold, Silver & More" },
  { icon: BadgeCheck, label: "18K · 22K · 24K Gold" },
  { icon: Instagram, label: "Follow Us on Instagram" },
];

export const TrustStrip = () => (
  <section className="relative border-y border-border bg-background-alt py-8 sm:py-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8">
      {items.map(({ icon: Icon, label }, idx) => (
        <div
          key={idx}
          className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 justify-center text-center sm:text-left"
        >
          <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
            <Icon className="h-5 w-5 text-primary" />
          </div>
          <span className="text-xs sm:text-sm font-medium text-foreground/90">{label}</span>
        </div>
      ))}
    </div>
  </section>
);
